import * as React from "react";
import { AsyncReactComponent } from "./AsyncReactComponent";
import { CopyToClipboardButtonComponent } from "./CopyToClipboardButtonComponent";
import { IErrorDetails, ErrorUtil } from "../ErrorUtil";

export interface IApiErrorProps {
    error: IErrorDetails;
}
interface IApiErrorState {
    displayStackTrace: boolean;
}

export class ApiErrorComponent extends AsyncReactComponent<IApiErrorProps, IApiErrorState>{
    constructor(props) {
        super(props);
        this.state = { displayStackTrace: false };
    }

    renderStackTrace(): JSX.Element[] {
        let components: JSX.Element[] = [];
        if (!this.props.error.exception || !this.props.error.exception.stackTrace) return null;
        components.push(<i key="chevron" className={"pull-right fa fa-chevron-" + (this.state.displayStackTrace ? "up" : "down")} onClick={() => { this.setState({ displayStackTrace: !this.state.displayStackTrace }) }}></i>)
        if (this.state.displayStackTrace) {
            components.push(<CopyToClipboardButtonComponent key="copy" text={this.props.error.exception.stackTrace} />);
            components.push(<pre key="pre">{this.props.error.exception.stackTrace}</pre>);
            if (this.props.error.exception.innerException) {
                components.push(<ApiErrorComponent key="ie" error={{ exception: this.props.error.exception.innerException, statusCode: 0, statusText: null }} />);
            }
        }

        return components;
    }
    render() {
        var msg = ErrorUtil.toString(this.props.error);
        return <div className="alert alert-danger">{msg}
            {this.renderStackTrace()}
        </div>;
    }
}
